export const DEFAULT_TIMER = '00:00:00';

/** setTimeout's ceiling (2^31 - 1 ms, about 24.8 days). A longer delay fires at once. */
export const MAX_TIMEOUT_MS = 2_147_483_647;

export const formatTime = (value: number, unit?: 's' | 'ms', t?: any): string => {
  const ms = unit === 's' ? value * 1000 : value;

  const totalSeconds = Math.floor(ms / 1000);
  const totalMinutes = Math.floor(totalSeconds / 60);
  const totalHours = Math.floor(totalMinutes / 60);
  const days = Math.floor(totalHours / 24);

  const hours = totalHours % 24;
  const minutes = totalMinutes % 60;
  const seconds = totalSeconds % 60;

  const hoursStr = `${hours.toString().padStart(2, '0')}`;
  const minutesStr = `${minutes.toString().padStart(2, '0')}`;
  const secondsStr = `${seconds.toString().padStart(2, '0')}`;

  if (totalHours >= 24) {
    const daysUnit = t ? t('time.days.short') : 'd';
    const hoursUnit = t ? t('time.hours.short') : 'h';
    return `${days}${daysUnit}:${hoursStr}${hoursUnit}`;
  }
  return `${hoursStr}:${minutesStr}:${secondsStr}`;
};
